import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Popup from '../RegisterScreen/Popup';
import { api } from '../../Constant';

const Billingform = (props) => {
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        address: '',
        state: '',
        city: '',
        pinCode: '',
        email: '',
        phone: '',
    });

    // Suggestion 2: Add loading state
    const [isLoading, setIsLoading] = useState(false);

    // Popup states for showing response
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupTitle, setPopupTitle] = useState('Notification');
    const [popupType, setPopupType] = useState('success');

    // Fetch states on component mount
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const response = await fetch(api + 'state_list', { method: 'POST' });
                const data = await response.json();
                if (data.success === "true") {
                    // Note: API returns data in a 'product' key.
                    setStates(data.product || []);
                } else {
                    console.error('Failed to fetch states:', data.message);
                }
            } catch (error) {
                console.error('Error fetching states:', error);
            }
        };
        fetchStates();
    }, []);

    // Suggestion 3: Simplify city fetching logic
    // Fetch cities only when the state in formData changes.
    useEffect(() => {
        const fetchCities = async (stateId) => {
            try {
                const response = await fetch(api + 'city_list', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ state_id: stateId }),
                });
                const data = await response.json();
                if (data.success === "true") {
                    setCities(data.product || []);
                } else {
                    console.error('Failed to fetch cities:', data.message);
                    setCities([]); // Clear cities on failure
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
                setCities([]); // Clear cities on error
            }
        };

        if (formData.state) {
            fetchCities(formData.state);
        } else {
            setCities([]); // If no state is selected, clear cities
        }
    }, [formData.state]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
        // When state changes, reset the city
        if (name === "state") {
            setFormData({ ...formData, state: value, city: "" });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Suggestion 1: Differentiate between a regular user and a guest user
        const userId = localStorage.getItem('userId');
        const guestId = localStorage.getItem('guest_id');
        const isGuest = guestId && userId === guestId;

        if (!userId) {
            setPopupMessage('No user or guest session found. Please log in.');
            setPopupTitle('Error');
            setPopupType('error');
            setPopupVisible(true);
            setIsLoading(false);
            return;
        }

        const identifier = isGuest ? { guest_id: guestId } : { user_id: userId };

        const formDataToSubmit = {
            ...identifier, // This will add either {user_id: id} or {guest_id: id}
            first_name: formData.firstName,
            last_name: formData.lastName,
            address: formData.address,
            state: formData.state,
            city: formData.city,
            pin_code: formData.pinCode,
            email_id: formData.email,
            phone_number: formData.phone,
        };

        try {
            const response = await fetch(api + 'add_address', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formDataToSubmit),
            });
            const data = await response.json();

            if (data.success === "true") {
                setPopupMessage('Address added successfully!');
                setPopupTitle('Success');
                setPopupType('success');
                setTimeout(() => navigate('/Billing-Address'), 1500);
            } else {
                setPopupMessage(data.message || 'Failed to add address.');
                setPopupTitle('Error');
                setPopupType('error');
            }
        } catch (error) {
            setPopupMessage(`An error occurred: ${error.message}`);
            setPopupTitle('Error');
            setPopupType('error');
        } finally {
            setIsLoading(false);
            setPopupVisible(true);
        }
    };

    const handleClosePopup = () => setPopupVisible(false);

    // Suggestion 4: Add accessibility attributes (htmlFor, id)
    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="add-address-tittle">
                        <h5>Add New Address</h5>
                    </div>
                </div>
            </div>
            <form className="row billing-form" onSubmit={handleSubmit}>
                <div className="col-lg-6 col-sm-6 col-md-6">
                    <label htmlFor="firstName">First Name <sup>*</sup></label><br />
                    <input id="firstName" type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleInputChange} required disabled={isLoading} />
                </div>
                <div className="col-lg-6 col-sm-6 col-md-6">
                    <label htmlFor="lastName">Last Name<sup>*</sup></label><br />
                    <input id="lastName" type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleInputChange} required disabled={isLoading} />
                </div>
                <div className="col-lg-12 col-sm-12 col-md-12">
                    <label htmlFor="address">Address<sup>*</sup></label><br />
                    <textarea id="address" name="address" placeholder="Address" value={formData.address} onChange={handleInputChange} required disabled={isLoading}></textarea>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                    <label htmlFor="state">State<sup>*</sup></label><br />
                    <select id="state" name="state" value={formData.state} onChange={handleInputChange} required disabled={isLoading}>
                        <option value="">Select State</option>
                        {states.map((state) => (
                            <option key={state.state_id} value={state.state_id}>{state.state_name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                    <label htmlFor="city">City<sup>*</sup></label><br />
                    <select id="city" name="city" value={formData.city} onChange={handleInputChange} required disabled={isLoading || !formData.state}>
                        <option value="">Select City</option>
                        {cities.map((city) => (
                            <option key={city.city_id} value={city.city_id}>{city.city_name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                    <label htmlFor="pinCode">Pin Code<sup>*</sup></label><br />
                    <input id="pinCode" type="text" name="pinCode" placeholder="Pin Code" value={formData.pinCode} onChange={handleInputChange} required disabled={isLoading} pattern="\d{6}" title="Pin code must be 6 digits" />
                </div>
                <div className="col-lg-8 col-md-4 col-sm-4">
                    <label htmlFor="email">Email Id<sup>*</sup></label><br />
                    <input id="email" type="email" name="email" placeholder="Email" value={formData.email} onChange={handleInputChange} required disabled={isLoading} />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4">
                    <label htmlFor="phone">Phone Number<sup>*</sup></label><br />
                    <input id="phone" type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleInputChange} required maxLength="10" pattern="\d{10}" title="Phone number must be 10 digits" disabled={isLoading} />
                </div>
                <div className="col-lg-12 sub-button">
                    <button type="submit" className="submit" disabled={isLoading}>
                        {isLoading ? 'SUBMITTING...' : 'SUBMIT'}
                    </button>
                    <Link to={props.nav || "/Billing-Address"} className="cancel" onClick={props.event}>CANCEL</Link>
                </div>
            </form>
            {popupVisible && (
                <Popup message={popupMessage} title={popupTitle} type={popupType} onClose={handleClosePopup} />
            )}
        </>
    );
};

export default Billingform;